/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Completed_LabelInputs */

const en_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const fr_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const de_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollendet`)
};

const it_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato`)
};

const ru_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершенный`)
};

const es_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminado`)
};

const zh_cn2_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全的`)
};

const ja_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const hi_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुरा होना।`)
};

const pt_pt2_snapshot_history_completed_label = /** @type {(inputs: Snapshot_History_Completed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Snapshot_History_Completed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_completed_label = /** @type {((inputs?: Snapshot_History_Completed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Completed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_completed_label(inputs)
	if (locale === "de") return de_snapshot_history_completed_label(inputs)
	if (locale === "it") return it_snapshot_history_completed_label(inputs)
	if (locale === "ru") return ru_snapshot_history_completed_label(inputs)
	if (locale === "es") return es_snapshot_history_completed_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_completed_label(inputs)
	if (locale === "ja") return ja_snapshot_history_completed_label(inputs)
	if (locale === "hi") return hi_snapshot_history_completed_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_completed_label(inputs)
	return en_snapshot_history_completed_label(inputs)
});